import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Bootstrap Vue
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// 自定义样式
import '@/assets/styles/main.scss'

// 全局注入 API 服务，确保组件内可通过 this.$api 调用
import api from '@/api'
Vue.prototype.$api = api

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.config.productionTip = false

const vm = new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    // 应用启动时检查登录状态
    this.$store.dispatch('checkAuthStatus')
  }
}).$mount('#app')

// 设置全局Vue实例引用，供API拦截器使用
window.vm = vm